import { createContext, useState } from "react"

export default createContext({
    isLoading: false,
    setIsLoading: () => {},
})


export const useInitRunBlueprint = () => {
    const [isLoading, setIsLoading] = useState()

    return {
        isLoading,
        setIsLoading
    }
}
